import React, { useContext, useEffect, useState } from "react"
import { UserContext } from '../UserContext'
import { useDispatch, useSelector } from "react-redux"
import { bindActionCreators } from "redux";
import { defaultAsset, Asset, AssetCreation } from "../AssetContext";
import { actionCreators, State } from "../state";
import { useHistory } from 'react-router-dom'
import LabelAndInput from "../components/LabelAndInput"
import { BackButton, DexxButton } from "../components/light/LightButton";
import Popup from '../components/Popup'
import { formValidationClearErrors, formValidationCheckObject } from '../utils'
import { PageDescription, TitleColor1 } from "../components/typography/Typogtaphy";
import { isLogged } from "../functions/session";
import { AssetCategory } from "../PoolContext";
import LoadingContainer from "../components/utils/LoadingContainer";
import { getFullCategoryName } from "../functions/assets";


export default function IssueAssetRoute(props: any): JSX.Element {

    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)

    const createAsset = useSelector((state: State) => state.createAsset)
    const [asset, setAsset] = useState<Asset>(defaultAsset)

    const [assetTypesByCat, setAssetTypesByCat] = useState<any>([])

    const [assetCurrencies, setAssetCurrencies] = useState<any>([])

    // Asset Fields:
    const [assetUuid, setAssetUuid] = useState("0")
    if (assetUuid === "0" && props.match.params.uuid)
        setAssetUuid(props.match.params.uuid)

    const [assetName, setAssetName] = useState<string>("")
    const [issuerName, setIssuerName] = useState<string>("")
    const [assetCategoryName, setAssetCategoryName] = useState<AssetCategory>("")
    const [assetTypeName, setAssetTypeName] = useState<string>("")
    const [currencyCode, setCurrencyCode] = useState<string>("")
    const [assetExtraInfo, setAssetExtraInfo] = useState<any>({})

    const [saved, setSaved] = useState(false)

    const [showPopUp, setShowPopUp] = useState<boolean>(false)
    const [titlePopUp, setTitlePopUp] = useState<string>("")
    const [msgPopUp, setMsgPopUp] = useState<string>("")
    function handleClosePopUp() {
        setTitlePopUp("")
        setMsgPopUp("")
        setShowPopUp(false)
    }

    const userCtx = useContext(UserContext)
    let history = useHistory<{ category: string }>()
    const logged = isLogged()

    useEffect(() => {
        if (userCtx && userCtx.name) setIssuerName(userCtx.name)
    }, [userCtx])

    var newAsset: AssetCreation = {
        asset_category: assetCategoryName,
        name: assetName,
        asset_type: assetTypeName,
        currency_cd: currencyCode,
        issuer_name: issuerName,
        extra_info: assetExtraInfo,
    }

    function handleExtraInfoRedirect() {
        history.push("/issuer/extra-info/" + assetUuid)
    }

    const assetSaved = assetUuid && assetUuid !== "0"

    useEffect(() => {
        if (history.location && history.location.state && history.location.state.category) {
            const state = history.location.state as { category: AssetCategory }
            let assetCategory: AssetCategory = state.category;
            setAssetCategoryName(assetCategory)
            actions.getAssetTypesByCategory(history.location.state.category, setAssetTypesByCat)
        }
    }, [history])

    useEffect(() => {
        if (assetSaved) actions.getAssetInfo(assetUuid, setAsset, logged)
        actions.getAssetCurrencies(setAssetCurrencies)
    }, [])

    useEffect(() => {
        if (saved && createAsset.payload) {
            switch (createAsset.payload[0]) {
                case 200:
                    if (createAsset.payload[1].error) {
                        setTitlePopUp("Sorry")
                        setMsgPopUp("We encountered an error saving your data.")
                    } else {
                        setAssetUuid(createAsset.payload[1].asset_uuid)
                        setTitlePopUp("Success")
                        setMsgPopUp("Your data has been saved.")
                    }
                    setShowPopUp(true)
                    setSaved(false)
                    break
                case 400:
                case 403:
                case 500:
                default:
                    setTitlePopUp("Sorry!")
                    setMsgPopUp("We encountered an error saving your data.")
                    setShowPopUp(true)
                    setSaved(false)
            }
            if (createAsset.payload[1].asset_uuid) actions.getAssetInfo(createAsset.payload[1].asset_uuid, setAsset, logged)
        }

    }, [createAsset.payload])

    useEffect(() => {
        if (asset && assetSaved) {
            let info: Asset = asset
            setAssetName(info.name)
            setIssuerName(info.issuer_name)
            setAssetCategoryName(info.asset_category)
            setAssetTypeName(info.asset_type)
            setCurrencyCode(info.currency_cd)
            setAssetExtraInfo(info.extra_info)
            actions.getAssetTypesByCategory(info.asset_category, setAssetTypesByCat)
        }
    }, [asset, assetUuid])

    function handleSaveAsset(e: React.MouseEvent) {
        formValidationClearErrors()
        const checkAsset = {
            asset_name: assetName,
            issuer_name: issuerName,
            currency_code: currencyCode,
            asset_type_name: assetTypeName
        }
        let count = formValidationCheckObject(checkAsset)
        if (count === 0) {
            let u = newAsset
            if (assetSaved) u.uuid = assetUuid
            setSaved(true)
            actions.createAsset(newAsset)
        } else {
            setTitlePopUp("Sorry!")
            setMsgPopUp("Please complete the highlighted fields.")
            setShowPopUp(true)
        }
    }

    return (<>
        <Popup show={showPopUp} title={titlePopUp} msg={msgPopUp} btnOk={true} close={handleClosePopUp} ></Popup>
        <LoadingContainer isReady={assetCategoryName !== "" && assetCurrencies.length > 0 && assetTypesByCat?.length > 0}>
            <div className="grid lg:grid-cols-4">
                <div className="grid justify-items-center xl:mt-40 md:mt-20 mt-10 col-span-1">
                    <PageDescription title={<div>{assetCategoryName + " Asset"}<br></br>Creation</div>}
                        description={""} />
                </div>

                <div className="flex flex-col md:grid md:px-20 md:grid-cols-2 mt-10 lg:col-span-2 gap-4" >
                    <div className="col-span-2 text-3xl mb-4 font-light"><TitleColor1>/ Asset Info</TitleColor1></div>
                    <LabelAndInput label={"Class"} value={getFullCategoryName(assetCategoryName)}
                        fun={() => { }} type={"disabled"} disabled />
                    <LabelAndInput required id={"assetTypeName"} label={"Type *"}
                        value={assetTypeName} fun={(e: string) => { setAssetTypeName(e) }}
                        type={"select"}
                        options={assetTypesByCat ?
                            [{ value: "", text: "" }].concat(assetTypesByCat.map((type: any) => {
                                return { value: type, text: type }
                            })) :
                            [{ value: "", text: "" }]} />

                    <LabelAndInput required id={"assetName"} label={"Asset Name *"} value={assetName}
                        fun={setAssetName} type={"text"} className={"col-span-2"} />
                    <LabelAndInput required id={"issuerName"} label={"Issuer Name *"} value={issuerName}
                        fun={setIssuerName} type={"text"} />
                    <LabelAndInput required id={"currencyCode"} label="FIMART Euro Voucher *"
                        value={currencyCode} fun={(e: string) => setCurrencyCode(e)}
                        type={"select"}
                        options={assetCurrencies ?
                            [{ value: "", text: "" }].concat(assetCurrencies.map((currency: any) => { return { value: currency, text: currency } })) :
                            [{ value: "", text: "" }]} />
                    <div className="col-span-2">
                        <div className="flex w-full mb-3 mt-6 md:my-6 gap-5 place-content-center ">
                            <BackButton className="px-5 rounded-lg" />
                            { assetSaved ? <DexxButton label={"Add Extra info"} onClick={handleExtraInfoRedirect}
                                className="rounded-lg px-5 hidden md:block" color2="warning" color3="warning_lightest" color1="warning"/> : <></>}
                            <DexxButton label={"save"} className="rounded-lg px-5"
                                color2="succ2" color3="succ2_lightest" color1="succ2" onClick={handleSaveAsset} />
                        </div>
                        {assetSaved ? <div className="flex w-full place-content-center md:my-6 md:hidden">
                            <DexxButton label={"Add Extra info"} onClick={handleExtraInfoRedirect}
                                className="rounded-lg px-5" color2="warning" color3="succ2_lightest" color1="succ2" />
                        </div> : <></>}
                    </div>
                </div>
            </div>
        </LoadingContainer>
    </>)
}
